import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { createApi } from "@reduxjs/toolkit/query/react";

const emailTemplateAPI = createApi({
    reducerPath: "emailTemplateAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getEmailTemplate: builder.mutation({
            query: (userQuery) => ({
                url: '/EmailTemplate/GetAllEmailTemplates',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addEmailTemplate: builder.mutation({
            query: (data) => ({
                url: `/EmailTemplate/AddEmailTemplate`,
                method: 'POST',
                body: transformRequest(data),
            }),
           // invalidateTags: ['addUser'],
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getEmailTemplateById:builder.query({
            query: (templateId) => ({
                url: `/EmailTemplate/GetEmailTemplatesById?templateId=${templateId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateEmailTemplate:builder.mutation({
            query: (data) => ({
                url: `/EmailTemplate/UpdateEmailTemplatesById`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteEmailTemplate:builder.mutation({
            query: (data) => ({
                url: `/EmailTemplate/DeleteEmailTemplatesById?id=${data}`,
                method: 'DELETE',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


    
    })
});

export const { 
    useGetEmailTemplateMutation,
    useAddEmailTemplateMutation,
    useLazyGetEmailTemplateByIdQuery,
    useUpdateEmailTemplateMutation,
    useDeleteEmailTemplateMutation,
  
 } =emailTemplateAPI;
 
export default emailTemplateAPI;